export default "__VITE_ASSET__D50rHT0V__"